module.exports = __webpack_public_path__ + "static/img/banner_a.21c6e3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_a.jpg
// module id = Y9VD
// module chunks = 1